import { Component, OnInit, Input , Output, EventEmitter} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

@Component({
	selector: 'app-trainer-declaration',
	templateUrl: './declaration.component.html',
	styleUrls: ['./declaration.component.css']
})

export class TrainerDeclarationComponent implements OnInit {
	loggedInUser: any;
	currentUserInfo: any;
	// 'googleReCaptchaDataSiteKey' =
	// 	environment['google-reCaptcha-data-site-key'];
	@Input() group: FormGroup;
	@Output() isCheck = new EventEmitter();
	isChecked = false;
	constructor(private currentUserService: CurrentUserService) {

	}

	ngOnInit() {
		this.loggedInUser = this.currentUserService.decodeToken();
		this._getCurrentUser();
		// this.isCheck.emit(this.isChecked);
	}
	catchGoogleRecaptchaRespone(captchaResponse) {
		// this.group.get('declaration').setValue(captchaResponse);
		this.group.get('declaration').setValue('captchaResponse');
	}

	isCheckedDeclaration() {
		this.isCheck.emit(this.isChecked);
	}
	_getCurrentUser() {
		this.currentUserService.getAdditionalInfomartion().subscribe(loggedInUser => {
			this.currentUserInfo = loggedInUser;
		});
	}
}
